import { render, staticRenderFns } from "./afterSales.vue?vue&type=template&id=f65b0cc4&"
import script from "./afterSales.vue?vue&type=script&lang=js&"
export * from "./afterSales.vue?vue&type=script&lang=js&"
import style0 from "./afterSales.vue?vue&type=style&index=0&id=f65b0cc4&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f65b0cc4')) {
      api.createRecord('f65b0cc4', component.options)
    } else {
      api.reload('f65b0cc4', component.options)
    }
    module.hot.accept("./afterSales.vue?vue&type=template&id=f65b0cc4&", function () {
      api.rerender('f65b0cc4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/general/Aftersales/afterSales.vue"
export default component.exports